const NotReadyHonoraireComp = () => (
  <li className="list-group-item">Patientez....</li>
);

export default NotReadyHonoraireComp;
